import React, { ChangeEvent, useCallback, FC, Dispatch, SetStateAction } from 'react'
import styles from 'styles/components/modal.module.scss'
import { Card, CardInner } from 'components/Card'
import { HorizontalLine, Spacer } from 'components/Utility'
import { FlexRow } from 'components/Flex'
import { CloseButton, OrangeButton } from 'components/Button'
import { Description, SubHeadline } from 'components/Typography'
import { TextInput } from 'components/Form'
import { FirebaseDocRefType } from 'firebase/index'
import { useDispatch } from 'react-redux'
import { updateDeliveryStatus } from 'reducks/storeShipping/operations'

type Props = {
  closeModal: () => void
  handleDelivered: () => void
  handleTrackingNumber: (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement>) => void
  open: boolean
  setShippedAt: Dispatch<SetStateAction<Date | null>>
  storeShippingRef: FirebaseDocRefType | undefined
  trackingNumber: string
}

const DeliveryConfirmationModal: FC<Props> = (props) => {
  const { closeModal, handleDelivered, handleTrackingNumber, open, setShippedAt, storeShippingRef, trackingNumber } =
    props
  const dispatch = useDispatch()

  const updateStatus = useCallback(() => {
    if (!storeShippingRef) return
    dispatch(updateDeliveryStatus(trackingNumber, storeShippingRef))
    setShippedAt(new Date())
    handleDelivered()
    closeModal()
  }, [dispatch, closeModal, handleDelivered, trackingNumber, setShippedAt, storeShippingRef])

  const closeConfirmationModal = () => {
    closeModal()
  }

  return (
    // styles.openクラスを適用するとopacityのアニメーションでフェードイン
    <div className={open ? styles.open : ''}>
      <div className={styles.overlay}>
        <div className={styles.overlay__background} onClick={closeConfirmationModal} />
        {open && (
          <div className={styles.overlay__container}>
            <Card>
              <CardInner>
                <FlexRow justifyContent={'between'}>
                  <SubHeadline headline={'商品を発送しましたか？'} />
                  <CloseButton onClick={closeConfirmationModal} />
                </FlexRow>
              </CardInner>
              <HorizontalLine verticalMargin={16} />
              <CardInner>
                <Description
                  description={
                    '商品を発送するとお客さまに発送されたことが、通知されます。配送業者の追跡番号を入力してください。'
                  }
                />
                <Spacer size={16} />
                <TextInput
                  disabled={false}
                  label={'追跡番号'}
                  maxLength={13}
                  onChange={handleTrackingNumber}
                  placeholder={'000011112222'}
                  required={true}
                  size={'small'}
                  type={'tel'}
                  value={trackingNumber}
                />
                <Spacer size={16} />
                <OrangeButton
                  disabled={trackingNumber.length === 0}
                  label={'この注文を発送済みにする'}
                  onClick={updateStatus}
                  size={'medium'}
                  type={'main'}
                />
              </CardInner>
            </Card>
          </div>
        )}
      </div>
    </div>
  )
}

export default DeliveryConfirmationModal
